import { render, staticRenderFns } from "./CreateVisit.vue?vue&type=template&id=851d5102"
import script from "./CreateVisit.ts?vue&type=script&lang=ts&external"
export * from "./CreateVisit.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports